/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200ResponseReissueOneOf
 */
export interface DisableDailyUserUsageLimit200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseReissueOneOf
     */
    'cardType': DisableDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const DisableDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type DisableDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum = typeof DisableDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum[keyof typeof DisableDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum];


